module.exports = __webpack_public_path__ + "img/hq-2026.5339be7a.jpg";